import React from "react";
import { saveAs } from "file-saver";
import { asBlob } from "html-docx-js-typescript";
import { buildHtmlDocument } from "./index";

export const generateDocx = async (
  query: string,
  prompt: string,
  results: string,
  resultImages: string[],
  markdownRef: React.RefObject<HTMLDivElement>
) => {
  if (![query, prompt, results].some((v) => v.trim()) && resultImages.length === 0) {
    alert("No data to download");
    return;
  }

  const htmlContent = `
    <h2>Kusto Query:</h2>
    <pre>${query.trim() || "No query"}</pre>
    <h2>Prompt:</h2>
    <pre>${prompt.trim() || "No prompt"}</pre>
    <h2>Results:</h2>
    <div>${markdownRef.current?.innerHTML ?? "No results"}</div>
  `;

  const formattedHtmlResults = buildHtmlDocument(htmlContent, { title: "Query Results" });

  if (!formattedHtmlResults) {
    alert("Error generating download");
    return;
  }

  try {
    const docxBlob = await asBlob(formattedHtmlResults);
    saveAs(docxBlob as Blob, "query-results.docx");
  } catch {
    alert("Error generating DOCX file");
  }
};
